// extracted by mini-css-extract-plugin
export var chip = "ExpiresOnChip-module--chip--be198";
export var container = "ExpiresOnChip-module--container--8fd58";
export var icon = "ExpiresOnChip-module--icon--5ded5";